export const test = {
  bind: () => {
    console.log('111');
  },
  update: () => { },
};
export function water(el, binding) {
  console.log(el, binding);
}
